import ReactGA from 'react-ga4';
import { useEffect, useState, useCallback } from 'react';
// import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
////////////////////////////////////////////////////////////////////
// import { telegramWebApp } from '@/main';
import {
	PageTitle,
	// Button,
} from '@/app/shared/components';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import { setEmailUpdated } from '@/core/redux/slices';
import { AuthService } from '@/core/services';
import { LeaderboardMappedResult } from '@/core/interfaces';

/**
 * Airdrop component that displays information about the airdrop rewards and actions.
 */
const Airdrop: React.FC = () => {
	/*********************
	// #region Constants
	**********************/
	// const reward = 100000;

	/*********************
	// #region Redux
	**********************/
	const { email, emailUpdated } = useCustomSelector(
		(state) => state.user.data
	);
	console.log(email)
	// const { tonWallet } = useCustomSelector((state) => state.counter);
	const { vtnAmount } = useCustomSelector((state) => state.user);
	console.log(vtnAmount)
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();
	const dispatch = useCustomDispatch();

	/*********************
	// #region States
	**********************/
	const [visibleDrawer, setVisibleDrawer] = useState<boolean>(false);
	console.log(visibleDrawer, setVisibleDrawer)

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/airdrop',
			title: 'Airdrop',
		});
	}, []);

	useEffect(() => {
		if (!emailUpdated) return;

		dispatch(setEmailUpdated(false));
	}, [emailUpdated]);


	const [activeTab, setActiveTab] = useState<Number>(-2);
	const getActiveTabLeaderBorad = useCallback(async (id:Number) => {
			try {
				setActiveTab(id)
			} catch (error) {
				console.error('Error counter taps:', error);
			}
	}, [setActiveTab]);
	const [leaderboard, setLeaderboard] = useState<LeaderboardMappedResult>({
		totalTapPoints: 0,
		leaderboard: [],
		userRank:0
	  });
	const [loading, setLoading] = useState(true); 

	useEffect(() => {
		const fetchLeaderboard = async () => {
			setLoading(true);
			try {
			  let resp = await AuthService.leaderboard(activeTab);
			  setLeaderboard(resp.userInfo);
			} catch (error) {
			  console.error("Error fetching leaderboard:", error);
			} finally {
				setLoading(false); // stop loader
			}
		};
		fetchLeaderboard();
	}, [activeTab]);
	
	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="flex flex-col gap-8 pt-8 pb-32 mx-4">
				{/* <div ref={coinsRef} className="counter">
					<Coins
						isAnimated={animateCoins}
						counter={counterAnimation}
					/>
				</div> */}

				<div className="flex flex-col gap-4 justify-center items-center">
					<img
						className="drop-shadow-2xl w-[80px]"
						src={process.env.VITE_AIRDROP_IMAGE}
					/>
					<div className="flex flex-col items-center">
						<PageTitle>{t('airdrop.title')}</PageTitle>
						<p className="text-sm">{t('airdrop.description')}</p>
					</div>
				</div>

				<div className="flex flex-col gap-2">
					{/* <div className="w-full flex flex-col gap-3">
						<div
							className="flex rounded-2xl items-center bg-selector-one-gradient p-3 option-menu-setting shadow-lg shadow-black/25"
							onClick={() => setVisibleDrawer(true)}
						>
							<div>
								<img
									className="w-[50px]"
									src={process.env.VITE_WALLET_IMAGE}
								/>
							</div>
							<div className="flex flex-col w-full ml-2 gap-1">
								<p className="text-sm font-semibold">
									{t('airdrop.connectVottunWorld')}
								</p>
								<div className="flex items-center ">
									<ShurikenIcon width={24} height={24} />

									<p className="pl-1 text-shadow font-bold text-sm">
										+{numify(reward)}
									</p>
								</div>
							</div>
							<div className="p-3">
								{email ? (
									<Checked />
								) : (
									<ArrowRight fillcolor="white" />
								)}
							</div>
						</div>
					</div> */}

					{/* <div className="w-full relative rounded-2xl bg-selector-two-gradient p-3 option-menu-setting shadow-lg shadow-black/25 ">
						<Link to={!tonWallet.account ? '/wallet' : ''}>
							<div className="flex items-center">
								<div>
									<img
										className="w-[50px]"
										src={process.env.VITE_BLUE_WALLET_IMAGE}
									/>
								</div>
								<div className="flex flex-col w-full ml-3 gap-1">
									<p className="text-sm font-semibold gap-2">
										{t('airdrop.connectVottunWallet')}
									</p>
									<div className="flex items-center ">
										<ShurikenIcon width={24} height={24} />

										<p className="pl-1 font-bold text-sm">
											+{numify(100000)}
										</p>
									</div>
								</div>
								<div className="px-3">
									{tonWallet.account ? (
										<Checked />
									) : (
										<ArrowRight fillcolor="white" />
									)}
								</div>
							</div>
						</Link>
					</div> */}
				</div>

				<div className="flex flex-col gap-2 justify-start">
					{/* Leaderboard Section */}
					<div className="mb-6">
						<div className="relative w-full rounded-2xl bg-selector-two-gradient p-4 shadow-lg shadow-black/25">
						<div className="flex flex-col gap-3">
							{/* Tabs */}
							<div className="flex items-center gap-2 mt-3">
								<button
									onClick={() => getActiveTabLeaderBorad(-2)}
									className={`w-1/2 rounded-lg py-2 text-xs sm:text-sm font-bold text-center ${
									activeTab === -2
										? "bg-pink-600 text-white"
										: "bg-pink-900/40 text-pink-300"
									}`}
								>
									ALL-TIME LEADERBOARD
								</button>

								<button
									onClick={() => getActiveTabLeaderBorad(0)}
									className={`w-1/2 rounded-lg py-2 text-xs sm:text-sm font-bold text-center ${
									activeTab === 0
										? "bg-pink-600 text-white"
										: "bg-pink-900/40 text-pink-300"
									}`}
								>
									SHURI V1 (OLD)
								</button>
							</div>

							{/* Content depending on active tab */}
							{activeTab === -2 ? (
							<div className="mt-4 text-white text-sm">
								<p>Your Rank: <span className="font-bold">#{leaderboard.userRank}</span></p>
								<p>Tap Points: <span className="font-bold">{leaderboard.totalTapPoints}</span></p>
								{loading ? (
									<p>Loading leaderboard...</p>
								) : (leaderboard.leaderboard.map((player, idx) => (
									<div
									key={player.userId}
									className="flex items-center justify-between mt-1"
									>
									<p className="text-white font-semibold">
										#{idx + 1} {player.userId}
									</p>
									<p className="text-white">{player.points} pts</p>
									</div>
								)))}
							</div>
							) : (
							<div className="mt-4 text-white text-sm">
								<p>Season Rank: <span className="font-bold">#{leaderboard.userRank}</span></p>
								<p>Season Points: <span className="font-bold">{leaderboard.totalTapPoints}</span></p>
								{loading ? (
									<p>Loading leaderboard...</p>
								) : (leaderboard.leaderboard.map((player, idx) => (
									<div
									key={player.userId}
									className="flex items-center justify-between mt-1"
									>
									<p className="text-white font-semibold">
										#{idx + 1} {player.userId}
									</p>
									<p className="text-white">{player.points} pts</p>
									</div>
								)))}
							</div>
							)}
						</div>
						</div>
					</div>
					</div>

					{/* Season Sections (existing) */}
					
					{/* Season 1 */}
					{/* <div className="mb-6">
						<h3 className="font-bold text-xl mb-3">
							{t('airdrop.titleSeason', {
								season: 1,
							})}
						</h3>

						<div className="flex items-center justify-between mb-3">
							<div className="flex gap-2 items-center">
								<img
									src={process.env.VITE_VTN_IMAGE}
									className="w-[20px] h-[20px]"
									alt="VTN"
								/>
								<p className="leading-none font-bold">VTN</p>
							</div>
							<div>{vtnAmount.toFixed(2)}</div>
						</div>

						<Button
							variant="secondary"
							onClick={() => {
								telegramWebApp.HapticFeedback.impactOccurred(
									'heavy'
								);
								telegramWebApp.openLink(
									'https://web3.vottun.io/signup'
								);
							}}
						>
							{t('airdrop.viewInVW')}
						</Button>
					</div> */}
					{/* Season 2 */}
					{/* <div className="mb-6">
						<h3 className="font-bold text-xl mb-3">
							{t('airdrop.titleSeason', {
								season: 2,
							})}
						</h3>

						<div className="flex items-center justify-between mb-3">
							<div className="flex gap-2 items-center">
								<img
									src={process.env.VITE_SHURI_COIN_IMAGE}
									className="w-[20px] h-[20px]"
									alt="VTN"
								/>
								<p className="leading-none font-bold">SHURI</p>
							</div>
							<div>0.00</div>
						</div>

						<Button variant="secondary" disabled>
							{t('general.comingSoon')}
						</Button>
					</div> */}
				</div>

			{/* <SyncVottunWorld
				isOpen={visibleDrawer}
				onClose={setVisibleDrawer}
			/> */}
		</>
	);
};

export default Airdrop;
